import { render } from "./ServiceRequest.vue?vue&type=template&id=1c96ce40"
import script from "./ServiceRequest.vue?vue&type=script&lang=js"
export * from "./ServiceRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__